import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../services/session-storage.service';

const VISITED_CREATIVESET_KEY = 'visitedCreativesetsWithHeavyVideos';

@Injectable({
    providedIn: 'root'
})
export class HeavyVideoTrackerService {
    private sessionStorageService = inject(SessionStorageService);

    isCreativeSetVisited(creativeSetId: string): boolean {
        const visitedCreativesetsWithHeavyVideos =
            this.sessionStorageService.getItem(VISITED_CREATIVESET_KEY) || [];
        return visitedCreativesetsWithHeavyVideos.includes(creativeSetId);
    }

    markCreativeSetVisited(creativeSetId: string): void {
        const visitedCreativesetsWithHeavyVideos =
            this.sessionStorageService.getItem(VISITED_CREATIVESET_KEY) || [];

        this.sessionStorageService.setSessionStorageItem(
            VISITED_CREATIVESET_KEY,
            JSON.stringify([...visitedCreativesetsWithHeavyVideos, creativeSetId])
        );
    }

    unmarkCreativeSetVisited(creativeSetId: string): void {
        const visitedCreativesets = this.sessionStorageService.getItem(VISITED_CREATIVESET_KEY) || [];

        const filteredCreativeSets = visitedCreativesets.filter(id => id !== creativeSetId);
        this.sessionStorageService.setSessionStorageItem(
            VISITED_CREATIVESET_KEY,
            JSON.stringify(filteredCreativeSets)
        );
    }
}
